/**
 * Detect network/timeout errors so the UI can show "server not ready" instead of generic errors.
 */

const NETWORK_ERROR_MESSAGES = [
  'failed to fetch',
  'network error',
  'networkrequestfailed',
  'load failed',
  'connection refused',
  'econnrefused',
];

export function isNetworkOrTimeoutError(err: unknown): boolean {
  if (err instanceof TypeError && err.message?.toLowerCase().includes('fetch')) {
    return true;
  }
  if (typeof (err as { name?: string })?.name === 'string') {
    const name = ((err as { name: string }).name || '').toLowerCase();
    if (name === 'aborterror' || name === 'timeouterror') return true;
  }
  const msg = err instanceof Error ? err.message : String(err);
  const lower = msg.toLowerCase();
  return NETWORK_ERROR_MESSAGES.some((m) => lower.includes(m));
}
